module.exports = __webpack_public_path__ + "media/auth/forgot_password-9a14dd75.svg";